import dayjs from "dayjs";
import { UcccNotifications } from "../../hooks/react-query/linehaul/useUcccNotifications";

export const notifications = {
  default: {
    notifications: [
      {
        shipmentId: 133336941,
        proNumber: "9848347",
        createdOn: dayjs(),
        destinationSic: {
          id: 1,
          code: "ONT",
          timeZone: "America/New_York",
        },
        originSic: {
          id: 1,
          code: "ONT",
          timeZone: "America/New_York",
        },
        type: "TripNotDesignated",
        tripNumber: null,
        gateCutTimestampUtc: dayjs().add(1, "day"),
      },
      {
        shipmentId: 133336942,
        proNumber: "9848348",
        createdOn: dayjs(),
        destinationSic: {
          id: 2,
          code: "EWR",
          timeZone: "America/New_York",
        },
        originSic: {
          id: 2,
          code: "EWR",
          timeZone: "America/New_York",
        },
        type: "LoadedTrip",
        tripNumber: 1234567890,
        gateCutTimestampUtc: dayjs().add(1, "day"),
      },
      {
        shipmentId: 133336943,
        proNumber: "9848349",
        createdOn: dayjs(),
        destinationSic: {
          id: 3,
          code: "ATL",
          timeZone: "America/New_York",
        },
        originSic: {
          id: 3,
          code: "ATL",
          timeZone: "America/New_York",
        },
        type: "LoadedTrip",
        tripNumber: 9876543210,
        gateCutTimestampUtc: dayjs().subtract(1, "day"),
      },
      {
        shipmentId: 133336944,
        proNumber: "9848350",
        createdOn: dayjs(),
        destinationSic: {
          id: 2,
          code: "EWR",
          timeZone: "America/New_York",
        },
        originSic: {
          id: 2,
          code: "EWR",
          timeZone: "America/New_York",
        },
        type: "DesignatedTrip",
        tripNumber: 1234567890,
        gateCutTimestampUtc: dayjs().add(1, "day"),
      },
      {
        shipmentId: 133336945,
        proNumber: "9848351",
        createdOn: dayjs(),
        destinationSic: {
          id: 3,
          code: "ATL",
          timeZone: "America/New_York",
        },
        originSic: {
          id: 3,
          code: "ATL",
          timeZone: "America/New_York",
        },
        type: "DesignatedTrip",
        tripNumber: 9876543210,
        gateCutTimestampUtc: dayjs().subtract(1, "day"),
      },
    ],
  },
} satisfies Record<string, UcccNotifications>;
